import '@/common/style/animation.styl'

import Sentry from 'sentry'
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import FastClick from 'fastclick'
import wxPlugin from '@/plugins/wx/index'
import httpPlugin from '@/plugins/request/index'
import logoloadingPlugin from '@/plugins/loading'
import storagePlugin from '@/plugins/storage'
import audioPlugin from '@/plugins/audio'
import bottomTipsPlugin from '@/plugins/bottom-tips'
import ConsultDialogPlugin from '@/plugins/consult-dialog'
import WatchDialogPlugin from '@/plugins/watch-dialog'
import consultBtnPlugin from '@/plugins/consult-btn'
import countdownPlugin from '@/plugins/countdown'
import qrcodeDialogPlugin from '@/plugins/qrcode-dialog'
import LazyImg from '@/components/lazy-img'
import app from './app'
import '@/common/js/polyfill'

import './load-vux'

const devMode = process.env.NODE_ENV === 'development'

/**
 * fixed ios11.3之后，输入框点击变得不灵敏
 * https://segmentfault.com/a/1190000015234652
 */
FastClick.prototype.focus = function(targetElement) {
  targetElement.focus()
}
FastClick.attach(document.body)

Vue.config.productionTip = devMode

const uploadErrorLoggerToSentry = (err, type = 'web') => {
  if (devMode) {
    console.error('%c接口错误', 'color:#fff;border-radius:4px;background:#f00;padding:2px 4px;', err)
  } else {
    Sentry.captureException(err, 'Request Error')
  }
}

const httpPluginConfig = {
  errorHandler(errorType, err) {
    switch (errorType) {
      case 'normalError':
      case 'RequestAbortedError':
      case 'AbortError':
        break
      default:
        uploadErrorLoggerToSentry(err)
        break
    }
  }
}

function handleFontSize() {
  console.log(1)
  // 设置网页字体为默认大小
  WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 })
  // 重写设置网页字体大小的事件
  WeixinJSBridge.on('menu:setfont', function() {
    WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 })
  })
}
if (typeof WeixinJSBridge === "object" && typeof WeixinJSBridge.invoke === "function") {
  handleFontSize()
} else {
  if (document.addEventListener) {
    document.addEventListener("WeixinJSBridgeReady", handleFontSize, false)
  } else if (document.attachEvent) {
    document.attachEvent("WeixinJSBridgeReady", handleFontSize)
    document.attachEvent("onWeixinJSBridgeReady", handleFontSize)  }
}

function audioAutoPlay(id){
  var audio = document.getElementById(id),
    play = function(){
      audio.play()
      document.removeEventListener("touchstart",play, false);
    }
  audio.play()
  document.addEventListener("WeixinJSBridgeReady", function() {//微信
    play()
  }, false)
  document.addEventListener("touchstart",play, false)
}
setTimeout(() => {
  audioAutoPlay('appAudio')
},2000)

// 悄悄测试，打枪的不要
// by 永佳
if (window.location.hash === '#test') {
  window.localStorage.clear()
  window.localStorage.setItem('test', '1')
} else if (window.location.hash === '#notest') {
  window.localStorage.removeItem('test')
}

Vue.use(audioPlugin)
Vue.use(bottomTipsPlugin)
Vue.use(ConsultDialogPlugin)
Vue.use(WatchDialogPlugin)
Vue.use(consultBtnPlugin)
Vue.use(countdownPlugin)
Vue.use(httpPlugin, httpPluginConfig)
Vue.use(LazyImg)
Vue.use(logoloadingPlugin)
Vue.use(qrcodeDialogPlugin)
Vue.use(storagePlugin)
Vue.use(VueAwesomeSwiper)
Vue.use(wxPlugin)

if (!devMode) {
  // 暂时下线
  // Sentry.init({
  //   dsn: 'https://50770fd317bc48188e62b8f8c20f9bdf@sentry.io/1368250',
  //   release: process.env.RELEASE_VERSION,
  //   environment: process.env.NODE_ENV,
  //   integrations: [new Sentry.Integrations.Vue({ Vue })]
  // })
}

window.addEventListener('pageshow', function(e) {
  //如果检测到页面是从“往返缓存”中读取的，刷新页面
  if (e.persisted) {
    location.reload()
  }
})

/* eslint-disable no-new */
new Vue(app)